import routes from '../routes';

export const getUrlFromNotification = ({
  id,
  action,
  entity_id,
  entity_bundle,
  child_id,
  child_bundle,
  comment_id,
}) => {
  let url;
  switch (action) {
    // case 'course':
    //   if (child_bundle && child_id) {
    //     // if (comment_id !== 0) {
    //     //   url = `${routes.courseDetails.path}/${entity_id}/${child_id}#comments`;
    //     //   break;
    //     // }
    //     url = `${routes.courseDetails.path}/${entity_id}/activities`;
    //     break;
    //   }
    //   url = `${routes.courseDetails.path}/${entity_id}/panoramica`;
    //   break;
    // case 'news':
    //   url = `${routes.newsDetails.path}/${entity_id}`;
    //   break;
    case 'newsletter_sent':
      url = `${routes.newsletterDetails.path}/${entity_id}`;
      break;
    case 'event_supervisor_rej':
      url = `${routes.editEvent.path}/${entity_id}`;
      break;
    case 'event_supervisor_app':
      url = `${routes.courseDetails.path}/${entity_id}/sessioni`;
      break;
    case 'event_tutor_update':
    case 'event_tutor_create':
      url = `${routes.previewEvent.path}/${entity_id}`;
      break;
    case 'event_reminder':
    case 'event_reminder_imm':
      url = `${routes.courseDetails.path}/${entity_id}/panoramica`;
      break;
    default:
      url = `${routes.notificationDetails.path}/${id}`;
      break;
  }
  return url;
};

export const CONSUMER_NOTIFICATIONS = [
  {
    id: 1,
    value: 'course_registration',
    label: 'Registrazione corso',
    icon: 'icon-window-new',
  },
  {
    id: 2,
    value: 'course_reminder',
    label: 'Corso in scadenza',
    icon: 'icon-clock',
  },
  // {
  //   id: 3,
  //   value: 'certificate_revoke',
  //   label: 'Revoca certificato',
  // },
  {
    id: 4,
    value: 'event_registration',
    label: 'Registrazione evento',
    icon: 'icon-calendar',
  },
  {
    id: 5,
    value: 'event_reminder',
    label: 'Reminder evento',
    icon: 'icon-calendar',
  },
  {
    id: 6,
    value: 'news_published',
    label: 'News',
    icon: 'icon-newspaper',
  },
  {
    id: 7,
    value: 'newsletter_sent',
    label: 'Newsletter in arrivo',
    icon: 'icon-message-text-square-02',
  },
  {
    id: 8,
    value: 'course_activities_up',
    label: 'Aggiornamento attività',
    icon: 'icon-message-text-square-02',
  },
  {
    id: 9,
    value: 'course_tutor_reply',
    label: 'Messaggio del tutor',
    icon: 'icon-message-text-square-02',
  },
  {
    id: 9,
    value: 'event_reminder_imm',
    label: 'Evento in arrivo',
    icon: 'icon-calendar',
  },
];

export const TUTOR_NOTIFICATIONS = [
  ...CONSUMER_NOTIFICATIONS,
  {
    id: 100,
    value: 'event_supervisor_rej',
    label: 'Evento rifiutato',
    icon: 'calendar-minus-01',
  },
  {
    id: 101,
    value: 'event_supervisor_app',
    label: 'Evento approvato',
    icon: 'calendar-check-01',
  },
  {
    id: 102,
    value: 'group_import',
    label: 'Import massivo',
    icon: 'users-plus',
  },
  {
    id: 103,
    value: 'group_import_error',
    label: 'Import massivo con errori',
    icon: 'users-plus',
  },
];

export const SUPERVISOR_NOTIFICATIONS = [
  ...CONSUMER_NOTIFICATIONS,
  {
    id: 200,
    value: 'event_tutor_create',
    label: 'Evento creato',
    icon: 'calendar-plus-01',
  },
  {
    id: 201,
    value: 'event_tutor_update',
    label: 'Evento aggiornato',
    icon: 'calendar-plus-01',
  },
  {
    id: 202,
    value: 'group_import',
    label: 'Import massivo',
    icon: 'users-plus',
  },
  {
    id: 203,
    value: 'group_import_error',
    label: 'Import massivo con errori',
    icon: 'users-plus',
  },
];

export const getIconByType = (item) => {
  let icon = '';
  switch (item?.action) {
    case 'course_registration':
      icon = 'icon-window-new';
      break;
    case 'activity_comment':
      icon = 'icon-commenti';
      break;
    case 'course_reminder':
      icon = 'icon-clock';
      break;
    case 'certificate_revoke':
      icon = 'icon-badge';
      break;
    case 'event_registration':
      icon = 'icon-calendar';
      break;
    case 'news_published':
      icon = 'icon-newspaper';
      break;

    default:
      break;
  }
  return icon;
};

export const getLabelByType = (item) => {
  let label = '';
  switch (item?.action) {
    case 'course_registration':
      label = 'Registrazione corso';
      break;
    case 'activity_comment':
      label = 'Commenti';
      break;
    case 'course_reminder':
      label = 'Corso in scadenza';
      break;
    case 'certificate_revoke':
      label = 'Revoca certificato';
      break;
    case 'event_registration':
      label = 'Registrazione evento';
      break;
    case 'news_published':
      label = 'News';
      break;
    case 'event_supervisor_rej':
      label = 'Evento rifiutato';
      break;
    case 'event_supervisor_app':
      label = 'Evento approvato';
      break;
    case 'event_tutor_create':
      label = 'Evento creato';
      break;
    case 'event_tutor_update':
      label = 'Evento aggiornato';
      break;
    case 'newsletter_sent':
      label = 'Newsletter in arrivo';
      break;
    case 'course_activities_up':
      label = 'Aggiornamento attività del corso';
      break;
    case 'course_tutor_reply':
      label = 'Messaggio del tutor';
      break;
    case 'event_reminder':
      label = 'Promemoria evento!';
      break;
    case 'event_reminder_imm':
      label = 'Promemoria evento imminente';
      break;
    case 'scorm_update':
      label = 'Aggiornamento pacchetto SCORM';
      break;
    case 'group_import':
      label = 'Import massivo';
      break;
    case 'group_import_error':
      label = 'Import massivo con errori';
      break;

    default:
      label = item?.action;
      break;
  }
  return label;
};

export const replaceCourseSubstrings = ({
  input = '',
  replaceWith = 'qui',
  hasLink = false,
}) => {
  const regex = /\$\{(.*?)\}/g;
  const results = [];
  let match;

  while ((match = regex.exec(input)) !== null) {
    results.push({
      fullMatch: match[0],
      title: replaceWith || match[1],
      id: match[1],
    });
  }

  let parsedBody = input;
  let singleReplace = '';
  for (const item of results) {
    if (hasLink) {
      singleReplace = `<a href="${routes.courseDetails.path}/${item.id}/panoramica" id="link-${item.id}" data-id="${item.id}">${item.title}</a>`;
    } else singleReplace = item.title;
    parsedBody = parsedBody.replace(item.fullMatch, singleReplace);
  }

  return parsedBody;
};
